export default __webpack_public_path__ + "static/media/MP_Profile_Education_01.57f00482.png";